<template>
  <v-dialog v-model="$store.state.loading" persistent width="400">
    <v-card class="p-4 card">
      <v-card-text> Permintaan diprosess, mohon menunggu {{ $store.state.loading }} </v-card-text>
      <v-progress-linear indeterminate color="#FF5700" class="mb-0"></v-progress-linear>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.card {
  padding: 2rem;
}
</style>

<script>
export default {
  name: 'loading',
};
</script>
